import styled, { css } from 'styled-components';
import {
  IconLabelButtonSizes,
  IconLabelButtonTypes,
} from './IconLabelButtonUtil';
import { Button as ReakitButton } from 'reakit/Button';
import { Button } from '@virtidev/toolbox';

const buttonCSS = css`
  ${({ $type, disabled, $size }) => css`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem 1.5rem;
    cursor: pointer;
    border-radius: 60px;
    color: #111b32;
    font-weight: normal;
    background-color: transparent;
    transition: background-color 0.2s, color 0.2s;
    font-size: 1rem;
    font-family: var(--text-font);

    border: 2px solid #c5cfd7;

    &:hover {
      background-color: white;
    }
    &:focus-visible {
      border-color: #fff;
      box-shadow: 0 0 0 2px var(--secondary-color);
    }

    ${$type === IconLabelButtonTypes.BLUE &&
    css`
      background-color: var(--primary-color);
      color: white;
      border-color: var(--primary-color);
      &:hover {
        background-color: var(--primary-color-light);
        border-color: var(--primary-color-light);
        color: white;
      }
      ${disabled &&
      css`
        background-color: var(--pd-disabled-button-bg-color);
      `}
    `}

    ${$type === IconLabelButtonTypes.GREY &&
    css`
      color: #a2afba;
      border-color: lightgrey;

      &:hover {
        background-color: white;
        color: #a2afba;
      }
    `}

    ${$size === IconLabelButtonSizes.SMALL &&
    css`
      font-size: 0.85rem;
      padding: 0.35rem 1.25rem;
    `}
    ${$size === IconLabelButtonSizes.LARGE &&
    css`
      font-size: 1.2rem;
    `}
    ${disabled &&
    css`
      border-color: var(--pd-disabled-button-bg-color);
      cursor: default;

      &:hover {
        border-color: var(--pd-disabled-button-bg-color);
        background-color: var(--pd-disabled-button-bg-color);
      }
    `}
  `}
`;

export const IconWrapper = styled.span`
  margin-right: 4px;
  display: flex;
  align-items: center;
`;

export const LegacyButton = styled(ReakitButton)`
  ${buttonCSS}
`;

export const NewButton = styled(Button)`
  white-space: nowrap;
  ${({ type }) => type !== IconLabelButtonTypes.BLUE && buttonCSS}
`;

export const ButtonLink = styled.a`
  ${buttonCSS}
`;
